window.rctools_openShareWindow = function(name,url,typeShare)
{
    let w = typeof w !== 'undefined' ? width : 550;
    var sTop = window.screen.height/2-(218);
    var sLeft = window.screen.width/2-(313);

    if(typeShare == "gettr"){
        window.open(url, 'sharer', 'toolbar=0,status=0,width=626,height=436,top=' + sTop + ',left=' + sLeft);
    }else{
        window.open(url,name,"height=450, width="+w+", top="+sTop+", left="+sLeft+", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0");
    }
}

window.shareOnFacebook = function(feedName, feedCaption, feedDescription, feedLink, feedPhoto){

    /**
     * If FB sdk not in page, load it and then come back to this
     */
    if(typeof FB == 'undefined'){
        load_fb_sdk();
        setTimeout(function(){
            shareOnFacebook(feedName, feedCaption, feedDescription, feedLink, feedPhoto);
        }, 125);
        return;
    }

    var ogImg = $('meta[property="og:image"]').attr('content');
    if( feedPhoto == "" ){
        if( ogImg != "" ){
            feedPhoto = ogImg;
        }else{
            feedPhoto = feedPhoto = document.domain+'/asset/img/og-default.png';
        }
    }

    FB.ui({
        method: 'feed',
        name: feedName,
        link: feedLink,
        caption:feedCaption,
        picture: feedPhoto,
        description: feedDescription
    }, function(response) {
        if(response && response.post_id){}
        else{}
    });

}

//fixex to include encode properly
function fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
}

//BUILDS EMAIL FORM
function rctools_genSendEmailsForm(share_url){

    var output = "<div class=\"send-btn-form\">"
        +     "<div id=\"msgBox\" style=\"display:none;\"></div>"
        +     "<div id=\"successBox\" style=\"display:none;\"><h3></h3></div>"
        +     "<div class=\"fieldset\">"
        +       "Your Name:<br />"
        +       "<input id=\"senderName\" name=\"name\" type=\"text\" /><br />"
        +       "Your E-mail:<br />"
        +       "<input id=\"senderEmail\" name=\"sEmail\" type=\"text\" /><br />"
        +       "<div class=\"emailLoader\" style=\"display:none;\"><img src=\"/images/ajax-loader.gif\" /></div>"
        +       "Friend\'s E-mail(s):<br />"
        +       "<input id=\"recpEmail\" name=\"recEmail\" type=\"text\" data-index=\"1\" />"
        +       "<div id=\"addEmail\" class=\"addEmailBtn\">+</div>"
        +       "<div id=\"addEmailForm\"></div>"
        +       "Message:(optional)<br />"
        +       "<textarea id=\"optMessage\" name=\"msg\" rows=\"4\" cols=\"25\"></textarea><br />"
        +       "<input id=\"sendBtn\" type=\"submit\" value=\"Send\" name=\"submit\">"
        +       "<div id=\"successClose\" style=\"display:none;\">Close</div>"
        +     "</div>"
        +   "</div>";
    return output;
}

//BUILDS SOCIAL BUTTONS
function rctools_genSocialToolsDropDown(share_url,share_title){

    var output = "";
    output += "<div class=\"social_tools\">"
        + "<div><a href=\"http://www.reddit.com/submit?url="+encodeURIComponent(share_url)+"\"><img src=\"https://www.reddit.com/static/spreddit5.gif\" alt=\"submit to reddit\" border=\"0\" /> Submit</a></div>"
        + "<div><script type=\"IN/Share\" data-url=\""+share_url+"\" data-counter=\"right\"></script></div>"
        //+ "<div><a href=\"http://www.tumblr.com/share\" title=\"Share on Tumblr\" style=\"display:inline-block; text-indent:-9999px; overflow:hidden; width:81px; height:20px; background:url('https://platform.tumblr.com/v1/share_1.png') top left no-repeat transparent;\">Share on Tumblr</a></div>"
        +   "<div><a onclick=\"rctools_openShareWindow('pinterestwindow','http://www.pinterest.com/pin/create/button/?url="+encodeURIComponent(share_url)+"&media=http://assets.realclearpolitics.com/images/logo-sub.gif&description="+encodeURIComponent(share_title)+"')\" data-pin-do=\"buttonPin\" data-pin-config=\"above\"><img src=\"//assets.pinterest.com/images/pidgets/pin_it_button.png\" /></a></div>"
        + "<div><div class=\"fb-like\" data-href=\""+share_url+"\" data-layout=\"button_count\"  data-action=\"like\" data-show-faces=\"false\" data-share=\"false\"></div></div><div class=\"clear\"></div>"
        + "<div><a href=\"https://twitter.com/share\" class=\"twitter-share-button\" data-related=\"RealClearNews,rcpvideo,TomBevanRCP\" data-count=\"horizontal\" data-lang=\"en\" >Tweet</a></div>"
        + "<div><g:plusone></g:plusone></div>"
        +   "<div><a href=\"javascript:void('0');\" id=\"print_all\"><img src=\"/images/printButton.gif\" /></a></div>"
        + "</div>";

    return output;
}

function initEmailDrawer(){
    //ICON BUTTONS WITH DRAWERS CLICK -- SHOW DRAWER
    var ref_title = $(document).find("title").text();
    var new_ref_title = ref_title.replace("'","");
    var refTitle = new_ref_title.replace("'","");
}
var printIcon = 0;
var articlesHome = document.querySelector('.sponsor');
var searchComment = document.querySelector('.tool.comments');
var videoTitle = document.querySelector('.video-title');
var moreCountId = 0;
function display_social_tools()
{
    var any_print_button = false;
    //IF SOCIAL TOOLS CONTAINER EXIST
    if($('div#fb-root').length<1) {
        $('body').append('<div id="fb-root"></div>'); //Add the fb-root if it doesn't exist already.
    }
    // ----------------------------
    //BUILD SOCIAL TOOLS ON ALL CONTAINER INSTANCES AND APPEND
    $(".socialBar .toolset").each(function(index){
        if($(this).is('.has-tools')) {
            return; //quit this function if the current item already has social tools.
            //this function will append the .has-tools class to $(this) at the end.
        }

        var sbIndex = index;
        //alert(sbIndex);
        var socialBar = $(this).parent();
        var socialBarParent = socialBar.parent(); //grandparent to socialBar

        var feedName = socialBarParent.attr("data-feed-name");
        if( feedName == "" || typeof feedName === 'undefined' ){
            //we have a discrepency in html markup different on targeting the elements for sharing tools for twitter
            feedName = socialBar.attr('data-src-title');

            if(feedName == "" || typeof feedName === 'undefined'){
                feedName = $(document).find("title").text();
            }
        }

        var feedCaption = socialBarParent.attr("data-feed-caption");
        if( feedCaption == "" || typeof feedCaption === 'undefined' ){
            feedCaption = $(document).find("description").text();
        }

        //var feedDescription = socialBarParent.attr("data-feed-description");
        var feedDesc = $('meta[name=description]').attr("content");

        var feedAuth = socialBar.attr("data-src-author");//Articles

        if(feedAuth == "" || typeof feedAuth === 'undefined'){
            //this will get the author from the Articles permalink pages
            feedAuth = $(".auth-author").text();
        }
        var feedDescription = feedDesc;

        if(feedAuth != '' || typeof feedAuth === 'undefined' && feedDesc != ''){
            feedDescription = feedDesc +' - By '+feedAuth;
        }

        if( feedDescription == "" || typeof feedDescription === 'undefined' ){
            feedDescription = $(document).find("description").text();
        }

        var feedLink = socialBarParent.attr("data-feed-link");
        if( feedLink == "" || typeof feedLink === 'undefined' ){
            feedLink = window.location.href;
        }

        //var feedLink = window.location.href;

        var feedPhoto = socialBarParent.attr("data-feed-photo");
        if( feedPhoto == "" || typeof feedPhoto === 'undefined' ){
            feedPhoto = $('meta[property="og:image"]').attr('content');
        }

        var shareStyle = socialBar.attr('data-style');
        var shareDialog = socialBar.attr('data-dialog');
        var shareTwitterHandle = socialBar.attr('data-handle');
        var authorPage = $('body').hasClass('author');

        var toolset = $(this);  //parent toolset element

        //GRABS REFERRAL URL
        var ref_url = socialBar.attr('data-src-url');
        if(!ref_url){
            //IF 'ref' non-existent pull current page url
            ref_url = window.location.href;
        }

        /**
         * E.M
         * Multipage data url
         * It will only exist if ther is a multi-page article
         */
        //if it is a multipage article
        if($('.multipage_article').length > 0){
            //var new_location = $(this).attr('data-url');
            ref_url = $('.multipage_article').attr('data-url');
        }

        //GRABS REFERRAL TITLE
        var ref_title = socialBar.attr('data-src-title');
        if(!ref_title){
            //IF 'title' non-existent pull current page meta-title
            ref_title = $(document).find("title").text();
        }

        //Replace requires a new variable name for each replace you do or it will not work
        var new_ref_title = ref_title;
        var refTitleClean = new_ref_title.replace("'","");
        var rtNoEm = refTitleClean.replace("<em>","");
        var refTitle = rtNoEm.replace("</em>", "");

        var red_btn_html = '<a href="//www.reddit.com/submit" style="margin-right:-3px; padding:0 0 0 7px;" onclick="window.location = \'//www.reddit.com/submit?url=\' + encodeURIComponent(window.location); return false"> <img width="30" src="/asset/img/reddit-icon.png" alt="submit to reddit" border="0" /> </a>';

        // Print Button
        var include_print = false;
        var print_icon_html = '';
        if(typeof socialBar.attr("data-print") !== 'undefined' && socialBar.attr("data-print") != '') {
            include_print = true;
            any_print_button = true;
            print_icon_html = "<a class=\"print_icon\"></a>";
        }

        //CUSTOM TWITTER TEXT FOR FEED TYPE SHARE DIALOGS
        var feed_temp = feedName.split('|');
        feedName = feed_temp[0];

        if(feedName.search('Articles ') !== -1){
            feedName = refTitle;
        }

        var twt_share_text = feedName + ' - ' + feedDescription;
        var new_twt_share_text = fixedEncodeURIComponent( feedName );

        var videoShare = document.querySelector('.video-social');

        if( shareStyle == "short" ){
            if( shareDialog == "feed" ){
                //APPEND TWITTER SHARE
                refTitle = refTitle.replace("039", "");
                refTitle = refTitle.replace("'", "");
                var share_url = 'https://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ new_twt_share_text +'&amp;related='+SITE_INFO['twitter_related'];
                toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");
                //APPEND FACEBOOK SHARE
                feedName = feedName.replace("'", "");
                toolset.append("<a class=\"icon fb_icon\" onclick=\"shareOnFacebook('"+feedName+"', '"+feedCaption+"', '"+feedDescription+"', '"+feedLink+"', '"+feedPhoto+"')\"></a>");
            
            }else{
                if(authorPage){
                    if (shareTwitterHandle){
                        toolset.append(`<a class="icon tweet_icon" href="https://twitter.com/${shareTwitterHandle}"></a>`)
                    }
                } else {
                    //APPEND TWITTER SHARE
                    refTitle = refTitle.replace("039", "");
                    refTitle = refTitle.replace("'", "");
                    feed_temp = refTitle.split('|');
                    refTitle = feed_temp[0];
                    share_url = 'https://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ new_twt_share_text +'&amp;related='+SITE_INFO['twitter_related'];
                    toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");
                }
                

                //APPEND FACEBOOK SHARE
                share_url = 'https://www.facebook.com/sharer/sharer.php?u='+ref_url;
                toolset.append("<a class=\"icon fb_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"')\"></a>");
                
                //APPEND GETTR SHARE
                var text = new_twt_share_text;
                var url = encodeURI(ref_url);
                share_url = 'https://gettr.com/share?&text='+text+'&url='+url;
                toolset.append("<a class=\"icon gettr_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"','gettr')\"></a>");
            }

            //Linked In global share url - used in short style sharing or when clicking the plus/more button menu
            var lin_share_url = 'https://www.linkedin.com/shareArticle?mini=true&url='+encodeURIComponent(ref_url)+'&title='+encodeURIComponent(refTitle)+'&summary='+encodeURIComponent(refTitle)+'&source='+SITE_INFO['site_title'];
            //Google Plus global share url - used in short style sharing when sharing is inside plus/more button menu
            var gp_share_url = 'https://plus.google.com/share?url='+ref_url;
            if(articlesHome == null && searchComment == null){
                printIcon++;
            }
            if(printIcon > 0){
                toolset.append("<a href=\"#comments-container\" class=\"tool comments\"><div class=\"comment-title-icon\" ></div></a>");
            }

            //APPEND MORE DRAWER
            toolset.append("<span class=\"more-wrapper\">"
                +   "<a class=\"icon jqDrawer more_icon plusIcon"+moreCountId+"\" onclick=\"showMenu("+moreCountId+")\"></a>"
                +   "<div class=\"toolset_drawer\">"
                +     "<div class=\"content\">"
                +     "<a class=\"icon lnkdin_icon\" onclick=\"rctools_openShareWindow('linkedinwindow','"+lin_share_url+"')\"></a> "
                +     red_btn_html
                +     "<span class=\"email-wrapper\">"
                +       "<a class=\"icon email_icon\" href=\"mailto:?subject="+encodeURIComponent(refTitle)+"&body="+ref_url+"\"></a>"
                +     "</span>"
                +     print_icon_html
                +     "</div>"
                +     "<div class=\"toolset_drawer_tab\"></div>"
                +   "</div>"
                + "</span>");
                moreCountId++;

        } //end short bar
        else if( shareStyle == "full" ){
            if( shareDialog == "feed" ){
                //APPEND TWITTER SHARE
                twt_share_text = twt_share_text.replace("039", "");
                twt_share_text = twt_share_text.replace("'", "");
                share_url = 'https://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ encodeURIComponent(twt_share_text) +'&amp;related='+SITE_INFO['twitter_related'];
                toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");

                //APPEND FACEBOOK SHARE
                feedName = feedName.replace("'", "");
                toolset.append("<a class=\"icon fb_icon\" onclick=\"shareOnFacebook('"+feedName+"', '"+feedCaption+"', '"+feedDescription+"', '"+feedLink+"', '"+feedPhoto+"')\"></a>");
                //APPEND FACEBOOK SHARE
                //share_url = 'https://www.facebook.com/sharer/sharer.php?u='+ref_url;
                //toolset.append("<a class=\"icon fb_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"')\"></a>");
                
                //APPEND GETTR SHARE
                var text = new_twt_share_text;
                var url = encodeURI(ref_url);
                share_url = 'https://gettr.com/share?&text='+text+'&url='+url;
                toolset.append("<a class=\"icon gettr_icon_footer\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"','gettr')\"></a>");
            }else{
                //APPEND TWITTER SHARE
                refTitle = refTitle.replace("039", "");
                refTitle = refTitle.replace("'", "");
                share_url = 'https://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ encodeURIComponent(refTitle) +'&amp;related='+SITE_INFO['twitter_related'];
                toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");

                //APPEND FACEBOOK SHARE
                share_url = 'https://www.facebook.com/sharer/sharer.php?u='+ref_url;
                toolset.append("<a class=\"icon fb_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"')\"></a>");

                //APPEND GETTR SHARE
                var text = new_twt_share_text;
                var url = encodeURI(ref_url);
                share_url = 'https://gettr.com/share?&text='+text+'&url='+url;
                toolset.append("<a class=\"icon gettr_icon_mobile\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"','gettr')\"></a>");
            }

            //APPEND LINKEDIN
            share_url = 'https://www.linkedin.com/shareArticle?mini=true&url='+encodeURIComponent(ref_url)+'&title='+encodeURIComponent(refTitle)+'&summary='+encodeURIComponent(refTitle)+'&source='+SITE_INFO['site_title'];
            toolset.append("<a class=\"icon lnkdin_icon\" onclick=\"rctools_openShareWindow('linkedinwindow','"+share_url+"')\"></a>");

            //APPEND GOOGLE+
            // share_url = 'https://plus.google.com/share?url='+ref_url;
            // toolset.append("<a class=\"icon gplus_icon\" onclick=\"rctools_openShareWindow('gpluswindow','"+share_url+"')\"></a>");

            //APPEND EMAIL MARKUP
            // toolset.append("<span class=\"more-wrapper\">"
            //     +   "<a class=\"icon email_icon\" href=\"mailto:?subject="+encodeURIComponent(refTitle)+"&body="+ref_url+"\"></a>"
            //     +   print_icon_html
            //     + "</span>");

        } //end full bar
        else if( shareStyle == "site" ){
            //APPEND TWITTER SHARE
            var site_url = SITE_INFO['global_site_url'];
            share_url = 'https://twitter.com/share?url='+encodeURIComponent(site_url);
            //share_url = share_url.replace("039", "");
            //share_url = share_url.replace("'", "");
            toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");

            //APPEND FACEBOOK SHARE
            share_url = 'https://www.facebook.com/sharer/sharer.php?u='+site_url;
            toolset.append("<a class=\"icon fb_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"')\"></a>");

            //APPEND GETTR SHARE
            var text = new_twt_share_text;
            var url = encodeURI(ref_url);
            share_url = 'https://gettr.com/share?&text='+text+'&url='+url;
            toolset.append("<a class=\"icon gettr_icon_footer\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"','gettr')\"></a>");
            
            //APPEND LINKEDIN
            share_url = 'https://www.linkedin.com/shareArticle?mini=true&url='+encodeURIComponent(site_url)+'&source='+SITE_INFO['site_title'];
            toolset.append("<a class=\"icon lnkdin_icon\" onclick=\"rctools_openShareWindow('linkedinwindow','"+share_url+"')\"></a>");

            //APPEND GOOGLE+
            // share_url = 'https://plus.google.com/share?url='+site_url;
            // toolset.append("<a class=\"icon gplus_icon\" onclick=\"rctools_openShareWindow('gpluswindow','"+share_url+"')\"></a>");

        }//end site bar
        else if( shareStyle == "mobile" ){
            //APPEND TWITTER SHARE
            share_url = 'https://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ new_twt_share_text +'&amp;related='+SITE_INFO['twitter_related'];
            toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");

            //APPEND FACEBOOK SHARE
            share_url = 'https://www.facebook.com/sharer/sharer.php?u='+ref_url;
            toolset.append("<a class=\"icon fb_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"')\"></a>");

            //APPEND GETTR SHARE
            var text = new_twt_share_text;
            var url = encodeURI(ref_url);
            share_url = 'https://gettr.com/share?&text='+text+'&url='+url;
            toolset.append("<a class=\"icon gettr_icon_mobile\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"','gettr')\"></a>");

            //APPEND SMS BUTTON
            let sms_body = ref_url;

            //var isIOS8 = function() {
            var deviceAgent = navigator.userAgent.toLowerCase();
            var isIOS = false;
            var sms_body_switch;
            if(/ipad|ipod|iphone/i.test(navigator.userAgent)) { //if ios
                //return /(iphone|ipod|ipad).* os 8_/.test(deviceAgent);
                var isIOS = true;
                if(isIOS){
                    if( /(iphone|ipod|ipad).* os 8_/.test(deviceAgent) ){
                        sms_body_switch = '&';
                    }else if( /(iphone|ipod|ipad).* os 7_/.test(deviceAgent) ){
                        sms_body_switch = ';';
                    }else{
                        sms_body_switch = '?';
                    }
                }
            }else{ //if anything BUT iOS

                sms_body_switch = '?';
            }

            //alert(sms_body_switch);

            toolset.append("<a class=\"icon sms_icon\" href=\"sms:"+ sms_body_switch +"body="+ ref_url +"\"></a>");

            //APPEND EMAIL MARKUP
            // toolset.append("<span class=\"more-wrapper\">"
            //     +   "<a class=\"icon email_icon\" href=\"mailto:?subject="+encodeURIComponent(refTitle)+"&body="+ref_url+"\"></a>">"
            //     //+   "</div>"
            //     + "</span>");

        }//end mobile bar
        else if( shareStyle == "mobile-video" ){
            //APPEND TWITTER SHARE
            share_url = 'https://twitter.com/share?url='+encodeURIComponent(ref_url)+'&amp;text='+ new_twt_share_text +'&amp;related='+SITE_INFO['twitter_related'];
            toolset.append("<a class=\"icon tweet_icon\" onclick=\"rctools_openShareWindow('twitterwindow','"+share_url+"')\"></a>");

            //APPEND FACEBOOK SHARE
            share_url = 'https://www.facebook.com/sharer/sharer.php?u='+ref_url;
            toolset.append("<a class=\"icon fb_icon\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"')\"></a>");

            //APPEND GETTR SHARE
            var text = new_twt_share_text;
            var url = encodeURI(ref_url);
            share_url = 'https://gettr.com/share?&text='+text+'&url='+url;
            toolset.append("<a class=\"icon gettr_icon_video\" onclick=\"rctools_openShareWindow('sharer','"+share_url+"','gettr')\"></a>");

            //APPEND SMS BUTTON
            let sms_body = ref_url;

            //var isIOS8 = function() {
            var deviceAgent = navigator.userAgent.toLowerCase();
            var isIOS = false;
            var sms_body_switch;
            if(/ipad|ipod|iphone/i.test(navigator.userAgent)) { //if ios
                //return /(iphone|ipod|ipad).* os 8_/.test(deviceAgent);
                var isIOS = true;
                if(isIOS){
                    if( /(iphone|ipod|ipad).* os 8_/.test(deviceAgent) ){
                        sms_body_switch = '&';
                    }else if( /(iphone|ipod|ipad).* os 7_/.test(deviceAgent) ){
                        sms_body_switch = ';';
                    }else{
                        sms_body_switch = '?';
                    }
                }
            }else{ //if anything BUT iOS

                sms_body_switch = '?';
            }

            //alert(sms_body_switch);

            toolset.append("<a class=\"icon sms_icon_video\" href=\"sms:"+ sms_body_switch +"body="+ ref_url +"\"></a>");

            //APPEND EMAIL MARKUP
            // toolset.append("<span class=\"more-wrapper\">"
            //     +   "<a class=\"icon email_icon\" href=\"mailto:?subject="+encodeURIComponent(refTitle)+"&body="+ref_url+"\"></a>">"
            //     //+   "</div>"
            //     + "</span>");

        }//end mobile bar

        $(this).addClass('has-tools');

    });

    var checkArticleType = document.querySelector('[data-layout]');
    var socialBarDiv = document.querySelector('.socialBar');
    if( checkArticleType != null && socialBarDiv != null && checkArticleType.dataset.layout == 'long'){
        socialBarDiv.classList.add('long');
    }

    if(any_print_button)
    {
        if($(".socialBar .print_icon").length)
        {
            $(".socialBar .print_icon").unbind('click');
            $(".socialBar .print_icon").click(function() {

                window.print();
            });
        }
    }
}

// function initSocialDrawer(){

//     //ICON BUTTONS WITH DRAWERS CLICK -- SHOW DRAWER
//     $(".jqDrawer").click(function(){
//         if($(this).parent().children(".toolset_drawer").is(':hidden')){
//             $(".socialBar .left .more-wrapper .toolset_drawer").hide(); //we must hide all other first
//             $(this).parent().children(".toolset_drawer").show(200); //SHOW ONE YOU CLICKED ON
//         }else{
//             $(this).parent().children(".toolset_drawer").hide(200);
//         }
//     });
// }

window.showMenu = function (id){
    //ICON BUTTONS WITH DRAWERS CLICK -- SHOW DRAWER
    if($('.plusIcon'+id).parent().children(".toolset_drawer").is(':hidden')){
        $(".socialBar .left .more-wrapper .toolset_drawer").hide(); //we must hide all other first
        $('.plusIcon'+id).parent().children(".toolset_drawer").show(200); //SHOW ONE YOU CLICKED ON
    }else{
        $('.plusIcon'+id).parent().children(".toolset_drawer").hide(200);
    }
}

function init_social_tools()
{
    display_social_tools();
    initEmailDrawer();
    //initSocialDrawer();
}

export default init_social_tools;